export default {
  labs: {
    label: 'Laboratório',
    requests: {
      label: 'Pedidos de Laboratório',
      new: 'Novo Pedido de Laboratório',
      view: 'Ver Laboratório',
      cancel: 'Cancelar Laboratório',
      complete: 'Completar Laboratório',
      error: {
        unableToRequest: 'Impossibilidade de criar um novo pedido de laboratório.',
        unableToComplete: 'Impossibilidade de completar o pedido de laboratório.',
        typeRequired: 'O tipo é necessário.',
        resultRequiredToComplete: 'O resultado é necessário para completar.',
      },
    },
    lab: {
      code: 'Código',
      status: 'Estado',
      for: 'Por',
      type: 'Tipo',
      result: 'Result',
      notes: 'Resultado',
      requestedOn: 'Perdiu em',
      completedOn: 'Completou em',
      canceledOn: 'Cancelou em',
      patient: 'Paciente',
    },
  },
}
